export class SystemUserUiSettings {
  CUSTOMER = 4;
  MANAGER = 3;
  ADMIN = 2;
  SUPER_ADMIN = 1;

  userType = {};
  childUsersType = "Customers";
  isCustomer = true;

  SetSessionVars(currentTabChaildId, currentTabChaildUserLevel) {
    sessionStorage.setItem("currentTabChaildId", currentTabChaildId); //current tab will act like this user is loged in
    sessionStorage.setItem(
      "currentTabChaildUserLevel",
      parseInt(currentTabChaildUserLevel)
    );
  }
  Logout() {
    sessionStorage.removeItem("currentTabChaildId"); //current tab will act like this user is loged in
    sessionStorage.removeItem("currentTabChaildUserLevel");
  }
  SetSessionCurrentTabChaildUserLevel(currentTabChaildUserLevel) {
    sessionStorage.setItem(
      "currentTabChaildUserLevel",
      parseInt(currentTabChaildUserLevel)
    );
  }
  Set(user) {
    this.userType = user;

    let sessionSystemUserType = sessionStorage.getItem(
      "currentTabChaildUserLevel"
    );

    if (sessionSystemUserType != null)
      this.userType.systemUserType = sessionSystemUserType;

    if (this.userType.systemUserType != 4) {
      this.isCustomer = false;
    }
    if (this.userType.systemUserType == 1) {
      this.childUsersType = "Admins";
    }
    if (this.userType.systemUserType == 2) {
      this.childUsersType = "Managers";
    }
    if (this.userType.systemUserType == 3) {
      this.childUsersType = "Accounts";
    }
  }
}
